export enum ActivationTrigger {
	FROM_DB_STORAGE = "fromDbStorage",
	ACTIVATED_BY_USER = "activatedByUser",
	EXPIRED_BENEFIT = "expiredBenefit",
	INCORRECTLY_ASSUMED = "IncorrectlyAssumed",
}
